import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const StateTradableColumn = ColumnTree.defineNode(
  'state-tradeable',
  ({ sortDirection, sortColumn, setSort }) => ({
    title: (
      <a
        href="#state"
        className={classnames('icon-sort', 'sortem', {
          [sortDirection]: sortColumn === 'state',
        })}
        onClick={() => setSort('state')}
      >
        <FormattedMessage
          id="marketplace-table-heading-orderstate"
          defaultMessage="State"
        />
      </a>
    ),
    key: 'tradeable',
    className: 'col-trade-status',
    render: (text, record) => (
      <div className="td-content">
        {record.state === 'tradeable' && (
          <span className="status-tradeable">
            <FormattedMessage
              id="marketplace-table-cell-tradeability-tradeable"
              description="Cell value, tradeability, 'tradeable'"
              defaultMessage="Tradeable"
            />
          </span>
        )}
        {record.state === 'untradeable' && (
          <>
            {record.is_owner ? (
              <span className="status-nottradeable">
                <FormattedMessage
                  id="marketplace-table-cell-tradeability-working"
                  description="Cell value, tradeability, 'working'"
                  defaultMessage="Working"
                />
              </span>
            ) : (
              <span className="status-nottradeable">
                <FormattedMessage
                  id="marketplace-table-cell-tradeability-untradeable"
                  description="Cell value, tradeability, 'untradeable'"
                  defaultMessage="Untradeable"
                />
              </span>
            )}
          </>
        )}
        {record.state === 'viewonly' && (
          <span className="status-viewonly">
            <FormattedMessage
              id="marketplace-table-cell-tradeability-viewonly"
              description="Cell value, tradeability, 'view only'"
              defaultMessage="View only"
            />
          </span>
        )}
        {record.state === 'sfc-tradeable' && (
          <span className="status-sfctradeable">SFC Tradeable</span>
        )}
      </div>
    ),
  })
);
